// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app_wrapper__3eig8","body":"app_body__2crj4"};